import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import generalIcon from '../../images/general.png';
import hardIcon from '../../images/hard.png';
import wineIcon from '../../images/wine.png';
import taigaIcon from '../../images/taiga_ai.png';
import japaneseIcon from '../../images/japanese.png';
import { useChat } from "../../contexts/ChatProvider";
import fallbackIcon from "../../images/maira_advisor_icon.png"

export const DPContainer = styled.div`
    width: 42px;
    height: 42px;
    margin-top: 21px;
    margin-left: 10px;
    box-sizing: border-box;
    user-select: none;
`;

const DisplayPicture = styled.img`
    width: 42px;
    height: 42px;
    box-sizing: border-box;
    border-radius: 50%; /* Use border-radius to create a circular shape */
    object-fit: cover; /* Crop the image to cover the container */
    object-position: top center; /* Position the image at the top center */
    border: 2px solid transparent; /* Default border color */
    position: relative;
    z-index: 1;
`;

export default function Avatar({
  user,
  icon,
}) {
  const { theme, colorSet } = useChat();
  const [avatarIcon, setAvatarIcon] = useState(null);

  const avatarMap = {
    general: generalIcon,
    hard: hardIcon,
    wine: wineIcon,
    japanese: japaneseIcon,
    maira: process.env.REACT_APP_MAIRA_LOGO_URL || "https://dz91s4us75f2i.cloudfront.net/maira_advisor_256x256_666b3f0ad1.png",
    taiga_ai: taigaIcon
    // Add more avatar types and their corresponding image paths here
  };

  const resolvedUrl =
    icon && icon.trim().length > 0 && Object.prototype.hasOwnProperty.call(avatarMap, icon)
      ? avatarMap[icon]
      : fallbackIcon;

  const [failedUrl, setFailedUrl] = useState(null);

  const src = failedUrl === resolvedUrl ? fallbackIcon : resolvedUrl;

  const avatarBorderColor = colorSet["--incoming-message-avatar-border-color"];

  return (
    <DPContainer>
      <DisplayPicture
        src={src}
        onError={() => {
          if (src !== fallbackIcon) setFailedUrl(resolvedUrl);
        }}
        style={{ borderColor: avatarBorderColor || theme }}
      />
    </DPContainer>
  );
}
